<template>
  <div class="sidebar-inner">
    <!-- Top Section -->
    <div class="top-section">
      <h4 class="mb-1">Office Transfers</h4>
      <hr>
      <claim-ticket :noBottomSpacing="true" :noTopSpacing="true"></claim-ticket>

      <!-- Is Loading -->
      <div class="text-center mt-4" v-if="isLoadingOfficeTransfers">
        <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
      </div>
      <!-- / Is Loading -->

      <!-- Loaded -->
      <div v-if="!isLoadingOfficeTransfers && officeTransfers !== null">
        <div class="office-transfer-data mt-3" v-if="officeTransfers.length === 0">
          <div class="property-card">
            <b class="property-name text-danger">
              No office transfers to show
            </b>
          </div>
        </div>
      </div>
      <!-- / Loaded -->

      <!-- Has Office Transfers -->
      <div v-if="!isLoadingOfficeTransfers && officeTransfers.length">
        <office-transfer v-for="officeTransfer in officeTransfersNewestFirst" :officeTransfer="officeTransfer" :key="`office-transfer-${officeTransfer.id}`"></office-transfer>
      </div>
      <!-- / Has Office Transfers -->
    </div>
    <!-- / Top Section -->
    <!-- Bottom Section -->
    <div class="bottom-section pt-3 pb-3">
      <create-office-transfers-modal @office-transfer-requested="handleOfficeTransferRequested"
       :ticket-id="ticket.id"></create-office-transfers-modal>
      <a href="#" @click.prevent="openCreateOfficeTransfersModal" class="btn btn-itg-dark btn-block">
        <i class="fa fa-plus mr-1"></i>
        Request Office Transfer
      </a>
    </div>
    <!-- / Bottom Section -->
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import CreateOfficeTransfersModal from "../widgets/CreateOfficeTransfersModal";
import ClaimTicket from '../widgets/TicketIntro/ClaimTicket.vue';
import OfficeTransfer from './OfficeTransfersSidebar/OfficeTransfer.vue';
// import Audit from "./AuditSidebar/Audit";
const _ = require('lodash');

export default {
  components: { CreateOfficeTransfersModal, OfficeTransfer, ClaimTicket }, 
  name: "OfficeTransfersSidebar",
  computed: {
    ...mapGetters('ticketViewer', {
      ticket: 'ticket',
      isLoadingOfficeTransfers: 'isLoadingOfficeTransfers',
      officeTransfers: 'officeTransfers'
    }),

    officeTransfersNewestFirst() {
      return _.reverse(this.officeTransfers);
    }
  },
  created() {
    this.loadOfficeTransfers();
  },
  methods: {
    ...mapActions('ticketViewer', {
      loadOfficeTransfers: 'loadOfficeTransfers',
      loadIfCanClaimTicket: 'loadIfCanClaimTicket'
    }),

    handleOfficeTransferRequested() {
      this.loadOfficeTransfers();
      this.loadIfCanClaimTicket();
    },

    openCreateOfficeTransfersModal() {
      this.$bvModal.show('create-office-transfers-modal');
    }
  }
}
</script>

<style scoped lang="scss">
.property-card {
    background: #fff;
    border-radius: 5px;
    padding: 15px;

    .property-name {
        font-weight: 600;
        color: #2c5cc5;
    }
}
</style>